import { render, staticRenderFns } from "./intervalSwiper.vue?vue&type=template&id=729f84f6&scoped=true&"
import script from "./intervalSwiper.vue?vue&type=script&lang=ts&"
export * from "./intervalSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./intervalSwiper.vue?vue&type=style&index=0&id=729f84f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f84f6",
  null
  
)

export default component.exports